import { personal } from "@/data/portfolio";
import { Instagram, Linkedin, Twitter, Mail } from "lucide-react";

const SOCIAL_LINKS = [
  { id: "email", href: `mailto:${personal.email}`, label: "Email", Icon: Mail, testid: "footer-email" },
  { id: "linkedin", href: personal.linkedin, label: "LinkedIn", Icon: Linkedin, testid: "footer-linkedin" },
  { id: "instagram", href: personal.instagram, label: "Instagram", Icon: Instagram, testid: "footer-instagram" },
  { id: "twitter", href: personal.twitter, label: "X", Icon: Twitter, testid: "footer-twitter" },
  { id: "behance", href: personal.behance, label: "Behance", Icon: BehanceIcon, testid: "footer-behance" },
];

function BehanceIcon({ size = 18 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M2 5h6.5a3 3 0 0 1 0 6H2zM2 11h7a3 3 0 0 1 0 6H2zM14 13a3 3 0 1 1 6 0H14a3 3 0 0 0 6 0M15 6h4" />
    </svg>
  );
}

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="site-foot" data-testid="site-footer">
      <div className="site-foot__top">
        <div className="serif foot-bigmark italic">Deepanshu&nbsp;Jha.</div>
        <div className="foot-meta">
          <span className="overline">© {year} — Crafted in {personal.location}</span>
          <span className="overline overline--muted">All work, all rights.</span>
        </div>
      </div>

      <div className="site-foot__socials" data-testid="footer-socials">
        {SOCIAL_LINKS.map(({ id, href, label, Icon, testid }) => (
          <a
            key={id}
            href={href}
            target={id === "email" ? undefined : "_blank"}
            rel={id === "email" ? undefined : "noreferrer"}
            className="foot-social"
            data-testid={testid}
            aria-label={label}
          >
            <Icon size={18} />
            <span>{label}</span>
          </a>
        ))}
      </div>

      <div className="site-foot__bottom">
        <span className="foot-link">{personal.email}</span>
        <button
          type="button"
          className="foot-link"
          onClick={() => {
            const lenis = window.__lenis;
            if (lenis) lenis.scrollTo(0, { duration: 1.5 });
            else window.scrollTo({ top: 0, behavior: "auto" });
          }}
          data-testid="footer-back-to-top"
        >
          Back to top ↑
        </button>
      </div>
    </footer>
  );
}
